<div class="flex-auto input-field-container {{field.customClass}}" *ngIf="field">
	<label [hidden]="field.UIOptions && field.UIOptions.showLabel === false">{{ fieldOptions.label || field.DisplayText
		}}</label>

	<p-password
		[formControl]="control"
		autocomplete="off"
		[toggleMask]="true"
		[feedback]="field.UIOptions?.PasswordField?.feedback !== false"
		[inputStyleClass]="!validPassword && !field.UIOptions?.PasswordField?.skipStrengthValidation ? 'ng-invalid' : ''"
		strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{6,12})(?=.*[`!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?~])"
		(onBlur)="onBlurField($event)"
		(onFocus)="onFocus($event)"
		(keyup)="onPasswordValidation($event)">
		<!--<ng-template pTemplate="header">
			<h6>Pick a password</h6>
		</ng-template>-->
		<ng-template pTemplate="footer" *ngIf="field.UIOptions?.PasswordField?.hasFooter">
			<p class="mt-2" *ngIf="field.UIOptions?.PasswordField?.suggestionsTitle">Suggestions</p>
			<ul class="validations" *ngIf="focusField">
				<li [ngClass]="{'ng-invalid': !validLength, 'success': validLength  }">
					Length must be between {{minLength}} and {{maxLength}} characters
				</li>
				<li [ngClass]="{'ng-invalid': !hasNumberCharacter, 'success': hasNumberCharacter}">
					Must have at least one number character</li>
				<li [ngClass]="{'ng-invalid': !hasUpperCase, 'success': hasUpperCase}">
					Must have at least one uppercase character</li>
				<li [ngClass]="{'ng-invalid': !hasSpecialCharacter, 'success': hasSpecialCharacter}">
					Must have at least one special character</li>
			</ul>
		</ng-template>
	</p-password>
	<p *ngIf="control?.errors?.mismatch" class="ng-invalid">
		<small>
			{{control?.errors?.mismatch?.message || ''}}
		</small>
	</p>
</div>
